
import React from 'react';

const PricingSection: React.FC = () => {
  const scrollToEnrollment = () => {
    const element = document.getElementById('enrollment');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-white relative overflow-hidden">
      {/* Patrón decorativo de fondo */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-10 left-10 text-6xl text-gray-400">🐾</div>
        <div className="absolute top-32 right-20 text-4xl text-gray-400">🐾</div>
        <div className="absolute bottom-20 left-1/4 text-5xl text-gray-400">🐾</div>
        <div className="absolute bottom-32 right-10 text-3xl text-gray-400">🐾</div>
      </div>
      
      <div className="max-w-6xl mx-auto px-6 relative">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Elige tu modalidad de pago
          </h2>
          <p className="text-lg text-gray-600">
            Ambas opciones incluyen acceso completo al curso
          </p>
        </div>
        
        <div className="flex flex-col lg:flex-row gap-8 justify-center items-stretch max-w-5xl mx-auto">
          {/* Tarjeta Pago Flexible */}
          <div className="bg-white border-2 border-gray-200 rounded-3xl p-12 flex-1 relative hover:shadow-xl transition-all duration-300">
            {/* Badge Popular */}
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
              <div className="bg-teal-500 text-white px-6 py-2 rounded-full text-sm font-medium">
                Más Popular
              </div>
            </div>
            
            <div className="text-center">
              <h3 className="text-3xl font-bold text-gray-900 mb-6 mt-4">
                Pago Flexible
              </h3>
              
              <div className="mb-8">
                <span className="text-6xl font-extrabold text-gray-900">99€</span>
                <span className="text-xl text-gray-500 ml-2">/mes</span>
                <div className="text-gray-600 mt-2">3 cuotas mensuales</div>
              </div>
              
              <ul className="space-y-4 mb-8">
                <li className="flex items-center text-gray-700">
                  <i className="ri-check-line text-teal-500 text-xl mr-3"></i>
                  <span>Acceso progresivo por módulos</span>
                </li>
                <li className="flex items-center text-gray-700">
                  <i className="ri-check-line text-teal-500 text-xl mr-3"></i>
                  <span>Sin intereses</span>
                </li>
                <li className="flex items-center text-gray-700">
                  <i className="ri-check-line text-teal-500 text-xl mr-3"></i>
                  <span>Cancela cuando quieras</span>
                </li>
              </ul>
              
              <button 
                onClick={scrollToEnrollment}
                className="w-full py-4 border-2 border-teal-500 text-teal-500 font-bold rounded-2xl hover:bg-teal-50 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                Seleccionar plan
              </button>
            </div>
          </div>
          
          {/* Tarjeta Pronto Pago */}
          <div className="bg-gradient-to-br from-teal-500 to-teal-600 text-white rounded-3xl p-12 flex-1 relative shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105">
            {/* Badge Ahorro */}
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
              <div className="bg-yellow-400 text-gray-900 px-6 py-2 rounded-full text-sm font-medium">
                Ahorra 17€
              </div>
            </div>
            
            <div className="text-center">
              <h3 className="text-3xl font-bold mb-6 mt-4">
                Pronto Pago
              </h3>
              
              <div className="mb-8">
                <div className="text-lg line-through text-teal-200 mb-1">297€</div>
                <span className="text-6xl font-extrabold">280€</span>
                <div className="text-teal-100 mt-2">Pago único</div>
              </div>
              
              <ul className="space-y-4 mb-8">
                <li className="flex items-center">
                  <i className="ri-check-line text-white text-xl mr-3"></i>
                  <span>Acceso total inmediato</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-white text-xl mr-3"></i>
                  <span>Todos los módulos desbloqueados</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-white text-xl mr-3"></i>
                  <span>Máximo ahorro</span>
                </li>
              </ul>
              
              <button 
                onClick={scrollToEnrollment}
                className="w-full py-4 bg-white text-teal-600 font-bold rounded-2xl hover:bg-gray-50 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                Matricularme ahora
              </button>
            </div>
          </div>
        </div>
        
        {/* Información adicional */}
        <div className="text-center mt-12">
          <div className="inline-flex items-center text-gray-600">
            <i className="ri-shield-check-line text-teal-500 mr-2"></i>
            <span>Garantía de satisfacción de 30 días</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
